import angular from 'angular';

import { Task, tasksApi } from '../../services/api';

/**
 * Minimal type just to meet requirements for this file
 */
interface TaskPartial {
  id: string;
  task: string;
  due_date_company: string;
  meeting_type: Task['meeting_type'];
  solved_at_company: string;
  solved: '0' | '1';

  /**
   * - 1 — Unit task
   * - 2 — Lead task
   * - 3 — Deal task
   */
  task_type: '1' | '2' | '3';
  task_unit_id: string | null;
  lead_id: string | null;
}

export class TasksDailyCtrl {
  static $inject = ['$scope', 'moment', '$state'];

  days: {
    [key: string]: {
      date: number;
      day: string;
      tasks: TaskPartial[];
    };
  } = {};

  constructor(
    $scope: angular.IScope,
    moment,
    private $state: { go(route: string, params: { [key: string]: any }): void },
  ) {
    this.days = {};

    $scope.$watch('vm.tasks', (tasks: TaskPartial[]) => {
      this.days = {};

      tasks.forEach((task) => {
        const d = Number(moment(task.due_date_company).format('YYYYMMDD'));
        const l = moment(task.due_date_company).format('LL');
        const dddd = moment(task.due_date_company).format('dddd');

        if (!(d in this.days)) {
          this.days[d] = { date: l, day: dddd, tasks: [] };
        }

        this.days[d].tasks.push(task);
      });
    });
  }

  isMeetingType(type: keyof typeof tasksApi.MEETING_TYPE, task: TaskPartial) {
    return task.meeting_type === tasksApi.MEETING_TYPE[type];
  }

  clickTask($event, task: TaskPartial) {
    if (angular.element($event.target).closest('a').length) {
      // skip if some link was closed
      return;
    }

    let route = '';
    let id = '';

    switch (task.task_type) {
      case '1':
        route = 'tasks.unitpopup';
        id = task.task_unit_id || '';
        break;
      case '2':
        route = 'tasks.leadpopup';
        id = task.lead_id || '';
        break;
      case '3':
        route = 'tasks.unitpopup';
        id = task.task_unit_id || '';
        break;
      default:
        throw new Error(`Unknown task type: ${task.task_type}`);
    }

    this.$state.go(route, { id });
  }
}
